import Vue from 'vue'
import VueI18n from 'vue-i18n'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import en from './lang/en'
import zh from './lang/zh'
import store from '../store/index';

Vue.use(VueI18n)

const messages = {
  en: {
    ...en,
    ...elementEnLocale
  },
  zh: {
    ...zh,
    ...elementZhLocale
  },
}

let lang=store.getters.lang==0?'zh':'en'
console.log('3283782=====dssgfg',store.getters.lang)
//  if(this.$store.getters.lang==0||this.$store.getters.lang==1){
//     lang=this.$store.getters.lang==0?'zh':'en'
//  }else{
    // lang='en'

    // lang='zh'
//  }

export const i18n = new VueI18n({
  locale: lang, 
  messages: messages
});


export default i18n;


// WEBPACK FOOTER //
// ./src/i18n/index.js